import column from './column'
import content from './content'
import market from './market'

import contentReview from './contentReview'
import contentRecycleBin from './contentRecycleBin'
import contentSearch from './contentSearch'
import template from './template'
import group from './group'
import field from './field'

import image from './image'
import video from './video'
import file from './file'
import banner from './banner'

import sensitiveWord from './sensitiveWord'
import ipBlockList from './ipBlockList'

import visual from './visual'

export default [
  column, // 栏目
  content, //内容
  market,//营销管理

  contentReview, // 内容审核
  contentRecycleBin, // 内容回收站
  contentSearch, // 内容搜索
  template, // 模板设置
  group, // 组别设置
  field, // 字段管理

  image, // 图片库
  video, // 视频库
  file, // 文件库
  banner, // banner图

  sensitiveWord, // 敏感词
  ipBlockList,  // ip黑名单

  visual, // 可视化页面
]



// WEBPACK FOOTER //
// ./src/core/modules/index.js